// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
export const VERSION = "0.0.3";
//# sourceMappingURL=version.js.map